import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Fired when a user invokes a skill via slash command',
  name: 'skill_invoked',
  params: [
    {
      description: 'ID of the invoked skill',
      name: 'skill_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The slash command used (e.g. /my-skill)',
      name: 'slash_command',
      required: true,
      type: 'string',
    },
    {
      description: 'ID of the canvas where the skill was invoked',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Whether the skill was invoked from the onboarding modal (blue Run button) vs the chat composer',
      name: 'is_invoked_from_onboarding',
      required: true,
      type: 'boolean',
    },
  ],
};

export default META;
